export default "__VITE_ASSET__Bnp4WBmh__"